export default "__VITE_ASSET__DNyIbdAN__"